<template>
	<div id="subjectAddEdit">
		<div class="top">
			<el-button @click="$router.go(-1)" type="default" size="medium">返回</el-button>
			<el-button size="medium" type="primary" @click="newManual">新建手册</el-button>
			<!-- <el-input size="medium" class="search-input search-input--right" placeholder="手册名称" v-model="searchName" @keyup.enter.native="getList">
				<el-button slot="append" icon="el-icon-search" size="medium" @click="getList"></el-button>
			</el-input> -->
		</div>
		<el-table :height="windowHeight - 223" :data="dataList" style="width: 100%" border>
			<el-table-column label="手册名称" align="center">
				<template slot-scope="scope">
					<span @click="$router.push('userManualList')">{{ scope.row.name }}</span>
				</template>
			</el-table-column>
			<el-table-column label="面向对象" align="center" show-overflow-tooltip>
				<template slot-scope="scope">
					<span v-if="scope.row.manager == 1">管理员</span>
					&nbsp;
					<span v-if="scope.row.teacher == 1">老师</span>
					&nbsp;
					<span v-if="scope.row.student == 1">学生</span>
					&nbsp;
				</template>
			</el-table-column>
			<el-table-column label="手册格式" show-overflow-tooltip align="center">
				<template slot-scope="scope">
					<span>{{ scope.row.format == 1 ? '文档' : '视频' }}</span>
				</template>
			</el-table-column>
			<el-table-column label="平台" width="200px" align="center" show-overflow-tooltip>
				<template slot-scope="scope">
					<span v-if="scope.row.wxj == 1">微校+</span>
					&nbsp;
					<span v-if="scope.row.abc == 1">农行掌银</span>
					&nbsp;
				</template>
			</el-table-column>
			<el-table-column label="链接" align="center" show-overflow-tooltip>
				<template slot-scope="scope">
					<a :href="scope.row.fileUrl" target="_blank" class="link">{{ scope.row.fileUrl }}</a>
				</template>
			</el-table-column>
			<el-table-column width="300" label="操作" align="center">
				<template slot-scope="scope">
					<el-button type="text" size="small" @click="editManual(scope.row)">编辑</el-button>
					<el-button type="text" size="small" @click="deleteModuleHelpManualById(scope.row.id)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-dialog :title="isAdd ? '新建手册':'编辑手册'" :visible.sync="dialogFormVisible" @close="closeDialog" :show-close="false">
			<div style="padding-top:20px;margin: 0 auto;">
				<el-form :model="formData" :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm">
					<el-form-item label="手册名称" prop="manualName">
						<el-input v-model="formData.manualName" maxlength="20" show-word-limit placeholder="请输入名称"></el-input>
					</el-form-item>
					<el-form-item label="面对对象" prop="faceObject">
						<el-checkbox-group v-model="formData.faceObject">
							<el-checkbox label="管理员"></el-checkbox>
							<el-checkbox label="教师"></el-checkbox>
							<el-checkbox label="学生"></el-checkbox>
						</el-checkbox-group>
					</el-form-item>
					<el-form-item label="手册格式">
						<el-radio v-model="formData.manualFormats" label="1">文档</el-radio>
						<el-radio v-model="formData.manualFormats" label="2">视频</el-radio>
					</el-form-item>
					<el-form-item label="链接" prop="url">
						<el-input v-model="formData.url" placeholder="请输入链接"></el-input>
					</el-form-item>
					<el-form-item label="平台" prop="platform">
						<el-checkbox-group v-model="formData.platform">
							<el-checkbox label="微校+"></el-checkbox>
							<el-checkbox label="农行掌银"></el-checkbox>
						</el-checkbox-group>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="addManual()">确 定</el-button>
			</div>
		</el-dialog>
		<!-- <div class="pagination-container">
			<el-pagination @size-change="sizeChangeHandler" @current-change="getList" :current-page.sync="listQuery.pageNo" :page-sizes="[10, 20, 30, 50]" :page-size.sync="listQuery.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
		</div> -->
	</div>
</template>

<script>
import Uploader from '@/components/Uploader/WebUploader'
import { insertModuleHelpManual, editModuleHelpManual, getManualByModuleHelpId, deleteModuleHelpManualById } from '@/api/userManual'
import mixin from '@/mixins/windowResize'

export default {
	name: 'subjectAddEdit',
	components: { Uploader },
	data() {
		return {
			bef: 0,
			isAdd: true,
			editId: '',
			dataList: [],
			dialogFormVisible: false,
			formData: {
				manualName: '',
				faceObject: ['管理员'],
				manualFormats: '1',
				url: '',
				platform: ['微校+'],
				moduleHelpId: ''
			},
			// listQuery: {
			// 	pageSize: 10,
			// 	pageNumber: 1
			// },
			total: 0,
			rules: {
				faceObject: [{ required: true, message: '请勾选面向对象', trigger: 'blur' }],
				platform: [{ required: true, message: '请勾选平台', trigger: 'blur' }],
				manualName: [{ required: true, message: '请输入手册名称', trigger: 'blur' }],
				url: [{ required: true, message: '请输入链接', trigger: 'blur' }]
			}
		}
	},
	mixins: [mixin],
	created() {
		this.formData.moduleHelpId = this.$route.query.moduleHelpId
		this.getManualByModuleHelpId()
	},
	methods: {
		newManual() {
      this.isAdd = true
			this.dialogFormVisible = true

		},
		editManual(item) {
			this.isAdd = false
			this.editId = item.id
			this.formData.manualName = item.name
			this.formData.url = item.fileUrl
			this.formData.moduleHelpId = item.moduleHelpId
			this.formData.manualFormats = item.format + ''
			this.formData.platform = []
			this.formData.faceObject = []
			item.wxj === 1 ? this.formData.platform.push('微校+') : ''
			item.abc === 1 ? this.formData.platform.push('农行掌银') : ''
			item.manager === 1 ? this.formData.faceObject.push('管理员') : ''
			item.teacher === 1 ? this.formData.faceObject.push('教师') : ''
			item.student === 1 ? this.formData.faceObject.push('学生') : ''
			this.dialogFormVisible = true
		},
		deleteModuleHelpManualById(id) {
			this.$confirm('此操作将永久删除该手册, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					deleteModuleHelpManualById({ id: id }).then(res => {
						this.getManualByModuleHelpId()
						this.$message({
							type: 'success',
							message: '删除成功!'
						})
					})
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					})
				})
		},
		getManualByModuleHelpId() {
			getManualByModuleHelpId({ moduleHelpId: this.formData.moduleHelpId }).then(res => {
				this.dataList = res.data.data
			})
		},
		addManual() {
			// 节流函数 解决连续点bug
			//获取当前时间戳
			var now = new Date().getTime()
			//如果当前时间减去上次时间大于限制时间时才执行
			if (now - this.bef > 1000) {
				this.$refs.ruleForm.validate(isValid => {
					if (isValid) {
						const args = {
							name: this.formData.manualName,
							fileUrl: this.formData.url,
							moduleHelpId: this.formData.moduleHelpId,
							format: this.formData.manualFormats,
							wxj: this.formData.platform.includes('微校+') ? 1 : 0,
							abc: this.formData.platform.includes('农行掌银') ? 1 : 0,
							manager: this.formData.faceObject.includes('管理员') ? 1 : 0,
							teacher: this.formData.faceObject.includes('教师') ? 1 : 0,
							student: this.formData.faceObject.includes('学生') ? 1 : 0
						}
						new Promise(resolve => {
							if (!this.isAdd) {
								args.id = this.editId
								editModuleHelpManual(args).then(resolve)
							} else {
								insertModuleHelpManual(args).then(resolve)
							}
						}).then(() => {
							this.getManualByModuleHelpId()
							this.$message.success(`${this.isAdd ? '新增' : '编辑'}成功`)
							this.idAdd = true
							this.editId = ''
							this.dialogFormVisible = false
						})
					}
				})
			}
			this.bef = now
		},
		sizeChangeHandler() {
			this.listQuery.pageNo = 1
			this.getList()
		},
		closeDialog() {
			this.$nextTick(v => {
				this.formData.manualName = ''
				this.formData.faceObject = ['管理员']
				this.formData.manualFormats = '1'
				this.formData.url = ''
				this.formData.platform = ['微校+']
			})
			this.$refs.ruleForm.clearValidate()
		}
	}
}
</script>

<style lang="scss">
#subjectAddEdit {
	padding: 12px;
	a,
	.link {
		color: #409eff;
		cursor: pointer;
	}
	.logo-image {
		height: 100px;
		margin-right: 10px;
		float: left;
	}

	.top {
		padding-bottom: 10px;
		margin-bottom: 20px;
	}

	.body {
		overflow: auto;
	}
}
</style>



// WEBPACK FOOTER //
// src/views/systemData/userManual/userManualList.vue